<template>
    <div class="score">
        <div  v-if="checkTime  && timeForm.status=='0'" style="width: 50%;text-align: center;margin: auto;margin-top: 30px;padding: 20px">
            <h2 style="text-align: center">{{new Date().getFullYear()}}年湖北省高校普通专升本成绩查询</h2>
            <div style="line-height: 40px;font-weight: bold" v-if="ddForm && ddForm.remark && ddForm.remark.indexOf('总分')>-1 && ddForm.remark.indexOf('排名')>-1">
                <h3 style="float: left;width: 50%;text-align: left;text-indent: 10px" v-if="parseInt(sumScore)>=0">总分：{{sumScore}}</h3>
                <h3 style="float: left;width: 50%;color: red;text-align: left;text-indent: 10px" v-else>总分：0</h3>
                <h3 style="float: right;width: 50%;color: red;text-align: right;">专业排名：{{level}}</h3>
            </div>
            <div style="line-height: 40px;font-weight: bold" v-if="ddForm && ddForm.remark && ddForm.remark.indexOf('总分')>-1 && ddForm.remark.indexOf('排名')==-1">
                <h3 style="float: left;width: 50%;text-align: left;text-indent: 10px" v-if="parseInt(sumScore)>=0">总分：{{sumScore}}</h3>
                <h3 style="float: left;width: 50%;color: red;text-align: left;text-indent: 10px" v-else>总分：0</h3>
            </div>
            <div style="line-height: 40px;font-weight: bold" v-if="ddForm && ddForm.remark && ddForm.remark.indexOf('总分')==-1 && ddForm.remark.indexOf('排名')>-1">
                <h3 style="float: right;width: 50%;color: red;text-align: right;">专业排名：{{level}}</h3>
            </div>
            <el-table border class="table-ui" :stripe="true"  :data="tableData" header-align="center" :header-cell-style="{'font-weight': 'bold','font-size': '18px','color': '#000'}">
                <el-table-column show-overflow-tooltip prop="majorItemName" label="科目名称" align="center"></el-table-column>
                <el-table-column show-overflow-tooltip prop="score" label="分数" align="center">
                    <template slot-scope="scope">
                        <span v-if="!scope.row.score && scope.row.score!=0">免试</span>
                        <span v-else-if="parseInt(scope.row.score)<0" style="color: red">违纪，取消成绩</span>
                        <span v-else>{{scope.row.score}}</span>
                    </template>
                </el-table-column>
                <div slot="empty"><no-data></no-data></div>
            </el-table>
<!--            <h4 style="width: 100%;color: #2b7ae1;line-height: 30px;text-align: left;text-indent: 10px">-->
<!--                注意:考生排名情况将于我校公示预录取名单时在本系统公布，请考生届时查阅。-->
<!--            </h4>-->
        </div>
        <div v-else style="width: 600px;text-align: center;margin:auto;margin-top: 100px;">
            <el-card class="box-card" >
                <div slot="header" class="clearfix">
                    <span style="color: red">通知</span>
                </div>
                <div class="text item" style="color: red">
                    <p>未开考，暂无法查询成绩</p>
                    <p>如有疑问请联系学院老师</p>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import fileDownload from "js-file-download";
    import noData from '@/components/noData/noData';
    export default {
        name: "sysScoreLook",
        components: { noData },
        data() {
            return {
                tableData: [],
                ticketTime:'',
                checkTime:'',
                timeForm:{

                },
                ddForm:{},
                sumScore:'',
                level:'',
            }
        },
        created(){
        },
        mounted(){
            axios({
                url:`${home}/sysDdList/checkSoreLookTime`,
                method:'GET'
            }).then(res=>{
                this.timeForm = res.data;
                this.checkTime = res.data2;
                if(res.data2){
                    this.submit();
                }
            }).catch(error=>{

            })
        },
        methods: {
            submit(){
                axios({
                    url:`${home}/sysStudentScore/findSysStudentScoresByStudentId`,
                    method:'GET',
                }).then(res=>{
                    this.tableData=res.data;
                    this.sumScore = res.data2[0];
                    this.level = res.data2[1];
                    this.ddForm = res.data3;
                }).catch(function (error) {
                    console.log(error);
                });
            },
        }
    }
</script>
<style lang="scss">
.score{
    .has-gutter{
        .el-table_1_column_1  .is-center   .is-leaf .el-table__cell{
            font-weight: bold !important;
        }
    }
}


</style>
